import React from 'react';

interface SecondaryButtonProps {
  text: string;
  href?: string;
  className?: string;
  onClick?: () => void;
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({ text, href, className = "", onClick }) => {
  const combinedClasses = `opus-button ${className}`;

  if (href) {
    return (
      <a href={href} className={combinedClasses}>
        {text}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={combinedClasses}>
      {text}
    </button>
  );
};

export default SecondaryButton;